import React, { useEffect, useState } from 'react';
import {Table, Container, Button} from 'react-bootstrap';
import classes from '../../WebsiteManagement/websiteManagement.module.css';
import Page from '../../pagination/pagination';
import { GetHolidays } from '../../../entities/action/action';

const PackageList = (props) => {
    const { onEditPackage } = props;
    const [dataSet,updateDataSet] = useState([]);
    const [count,updateCount] = useState(0)
    const postPerPage = 20;
    const [currentPage,updateCurrentPage] = useState(1);
    const indexOfLast = currentPage*postPerPage;
    const indexOfFirst = indexOfLast - postPerPage;
    const currentPosts = dataSet.slice(indexOfFirst,indexOfLast);
    const handleChangePage = (event,value)=>{
        updateCurrentPage(value)
    }
    useEffect(()=>{
        updateCount(Math.ceil(dataSet.length/postPerPage))
    },[dataSet])

      useEffect(() => {
        (async () => {
          try {
            const arr = await GetHolidays();
            if (arr?.success) {
              updateDataSet(Array.isArray(arr?.holidays) ? arr.holidays : []);
            }
          } catch {
            updateDataSet([]);
          }
        })();
      }, []);
 
    return(
        <Container fluid style={{padding:'0'}}>
            <Table striped bordered hover responsive>
                <thead>
                    <tr>
                        <th>S.No</th>
                        <th>Holiday ID</th>
                        <th>Name</th>
                        <th>Holiday Theme</th>
                        <th>Images</th>
                        <th>Starts On</th>
                        <th>Ends On</th>
                        <th>Category</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        currentPosts.length>0?currentPosts.map((data,key)=>
                            <tr key={data.id ?? key}>
                                <td>{indexOfFirst + key + 1}</td>
                                <td>{data.id}</td>
                                <td>{data.name}</td>
                                <td>{data.theme}</td>
                                <td>
                                    {data.images?.imageUrl ? (
                                        <img
                                            src={data.images.imageUrl}
                                            alt=""
                                            style={{
                                                height: '56px',
                                                width: '56px',
                                                objectFit: 'cover',
                                                borderRadius: '4px',
                                                display: 'block',
                                            }}
                                        />
                                    ) : (
                                        '—'
                                    )}
                                </td>
                                <td>{data.startDate ?? '—'}</td>
                                <td>{data.endDate ?? '—'}</td>
                                <td>{data.category?.categoryName ?? '—'}</td>
                                <td className={classes.CenterRow}>
                                    {onEditPackage && data?.id ? (
                                        <Button
                                            variant="outline-primary"
                                            size="sm"
                                            onClick={() => onEditPackage(data.id)}
                                        >
                                            Edit
                                        </Button>
                                    ) : null}
                                </td>
                            </tr>
                        ):null
                    }
                </tbody>
            </Table>
            <div style={{display:'flex',justifyContent:'center',margin:'15px 0'}}>
                <Page count={count} change={handleChangePage} page={currentPage}/> 
            </div>
        </Container>
    )
}
export default PackageList;